
import { Navigate, useLocation } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const queryClient = useQueryClient();
  
  // Set up auth state change listener
  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        console.log('Auth state changed:', event);
        // Update the session in the query cache
        queryClient.setQueryData(['session'], session);
      }
    );

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [queryClient]);

  // Query for session data with optimized caching
  const { data: session, isLoading, isError, error } = useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) throw error;
      return session;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - more aggressive caching
    refetchOnWindowFocus: false, // Reduce unnecessary refetches
    refetchOnMount: false, // Use cached data on mount
    retry: 1,
  });

  // TODO: Re-enable auth check - temporarily bypassed
  return <>{children}</>;
};

export default PrivateRoute;
